import { useState } from "react";
import { Menu, X } from "lucide-react";
import logoAsset from "@/assets/zenisoft-logo.png";

const nav = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solutions", label: "Solutions" },
  { to: "/astra", label: "Astra ERP" },
  { to: "/astra-pos", label: "Astra POS" },
  { to: "/industries", label: "Industries" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/contact", label: "Contact" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);
  const currentPath = typeof window === "undefined" ? "/" : window.location.pathname.replace(/\/+$/, "") || "/";
  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/80 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="/" className="flex items-center">
          <img src={logoAsset} alt="Zenisoft" className="h-10 md:h-12 w-auto" />
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {nav.map((n) => (
            <a
              key={n.to}
              href={n.to}
              aria-current={currentPath === n.to ? "page" : undefined}
              className={`text-sm transition-colors hover:text-foreground ${
                currentPath === n.to ? "text-foreground font-medium" : "text-muted-foreground"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a href="/contact" className="rounded-md bg-[var(--brand-navy)] px-4 py-2 text-sm font-medium text-white hover:opacity-90 transition">
            Request Demo
          </a>
        </div>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="flex flex-col p-4 gap-1">
            {nav.map((n) => (
              <a key={n.to} href={n.to} onClick={() => setOpen(false)} className="px-3 py-2 rounded-md text-sm hover:bg-muted">
                {n.label}
              </a>
            ))}
            <a href="/contact" onClick={() => setOpen(false)} className="mt-2 rounded-md bg-[var(--brand-navy)] px-3 py-2 text-sm font-medium text-white text-center">
              Request Demo
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
